import React from "react";
import './ContactInfo.css';
import { siteInfo } from '../data/siteInfo';

export function ContactInfo() {
    return (
        <article className="contact-info-card panel-surface">
            <p className="section-eyebrow">Kontakt & Standort</p>
            <h2 className="contact-info-card__title">Besuchen Sie uns in Hinwil</h2>
            <address className="contact-info-card__address">
                {siteInfo.addressLine1}
                <br />
                {siteInfo.addressLine2}
            </address>
            <p className="contact-info-card__line">
                <strong>Telefon:</strong>{' '}
                <a href={siteInfo.phoneHref}>{siteInfo.phone}</a>
            </p>
            <p className="contact-info-card__line">
                <strong>E-Mail:</strong>{' '}
                <a href={`mailto:${siteInfo.email}`}>{siteInfo.email}</a>
            </p>
            <p className="contact-info-card__line">
                <strong>Instagram:</strong>{' '}
                <a href={siteInfo.instagramUrl} target="_blank" rel="noreferrer">
                    {siteInfo.instagramHandle}
                </a>
            </p>
            <div className="contact-info-card__hours">
                <h3>Öffnungszeiten</h3>
                {siteInfo.openingHours.map((entry) => (
                    <p key={entry.days}>
                        <strong>{entry.days}:</strong> {entry.hours}
                    </p>
                ))}
            </div>
            <div className="contact-info-card__special-hours">
                <h3>Spezielle Öffnungszeiten</h3>
                <ul>
                    {siteInfo.specialOpeningHours.map((entry) => (
                        <li key={entry.date}>
                            <span>
                                <strong>{entry.displayDate}</strong>
                                {entry.name ? <small>{entry.name}</small> : null}
                            </span>
                            <strong className={entry.status ? "contact-info-card__closed" : undefined}>
                                {entry.hours ?? entry.status}
                            </strong>
                        </li>
                    ))}
                </ul>
            </div>
        </article>
    )
}
